module.exports = __webpack_public_path__ + "img/attenuation.b08bd490.svg";